var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
var Page = function (_a) {
    var children = _a.children;
    return (_jsx(Box, __assign({ sx: {
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            //backgroundImage: 'radial-gradient(circle, #D3E9FF 0%, #9BCDFF 100%)',
            backgroundSize: 'cover',
        } }, { children: children })));
};
export default Page;
